import { isMobileScreen } from './spacing';

const rootFontSize = 14;

export const fontSize = {
  input: 16,
  message: 15,
  xxs: rootFontSize - 4,
  xs: rootFontSize - 2,
  sm: rootFontSize,
  md: rootFontSize + 2,
  lg: rootFontSize + 4,
  xl: rootFontSize + 6,
  '2xl': rootFontSize + 10,
  '3xl': rootFontSize + 16,
  '4xl': rootFontSize + 22,
  '5xl': rootFontSize + 34,
  '6xl': rootFontSize + 46,
  '7xl': rootFontSize + 58,
  '8xl': rootFontSize + 82,
  '9xl': rootFontSize + 114,
  regular: isMobileScreen ? rootFontSize : rootFontSize + 2,
};

export const fontSizeRem = {
  xxs: fontSize.xxs / rootFontSize + 'rem',
  xs: fontSize.xs / rootFontSize + 'rem',
  sm: fontSize.sm / rootFontSize + 'rem',
  md: fontSize.md / rootFontSize + 'rem',
  lg: fontSize.lg / rootFontSize + 'rem',
  xl: fontSize.xl / rootFontSize + 'rem',
  '2xl': fontSize['2xl'] / rootFontSize + 'rem',
  '3xl': fontSize['3xl'] / rootFontSize + 'rem',
  '4xl': fontSize['4xl'] / rootFontSize + 'rem',
  '5xl': fontSize['5xl'] / rootFontSize + 'rem',
  '6xl': fontSize['6xl'] / rootFontSize + 'rem',
  '7xl': fontSize['7xl'] / rootFontSize + 'rem',
  '8xl': fontSize['8xl'] / rootFontSize + 'rem',
  '9xl': fontSize['9xl'] / rootFontSize + 'rem',
};
